import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/merge/customer.merge.consolidate.mutation.gql"
import type {
  CustomerMergeConsolidateMutation,
  CustomerMergeConsolidateMutationVariables,
} from "@/v2-backoffice-client/customer/merge/__types__/customer.merge.consolidate.mutation"

type Options = MutationHookOptions<
  CustomerMergeConsolidateMutation,
  CustomerMergeConsolidateMutationVariables
>

export function useCustomerMergeConsolidateMutation(options?: Options) {
  return useMutation<
    CustomerMergeConsolidateMutation,
    CustomerMergeConsolidateMutationVariables
  >(mutation, options)
}
